import { Icon, IconProps } from '@chakra-ui/react'
import React from 'react'

export const ProfileEmptyState = (props: IconProps) => {
  return (
    <Icon
      width="504"
      height="290"
      viewBox="0 0 509 300"
      fill="none"
      sx={{
        '.rect-1': {
          fill: '#F7FAFC',
        },
        '.rect-2': {
          fill: 'white',
        },
        '.rect-3': {
          fill: '#E6E6E6',
          stroke: '#E6E6E6',
        },
        '.rect-5': {
          stroke: '#CBD5E0',
        },
        _dark: {
          '.rect-1': {
            fill: 'white',
            fillOpacity: '0.04',
          },
          '.rect-2': {
            fill: '#2D3748',
          },
          '.rect-3': {
            fill: '#718096',
            stroke: '#718096',
          },
          '.rect-5': {
            stroke: 'white',
            strokeOpacity: '0.16',
            strokeWidth: '0.528579',
          },
        },
      }}
      {...props}
    >
      <path
        d="m489 138.26h-437c-11.046 0-20 8.954-20 20v69.479c0 11.046 8.9543 20 20 20h437c11.046 0 20-8.954 20-20v-69.479c0-11.046-8.954-20-20-20z"
        className="rect-1"
      />
      <path
        d="m184.42 17.709-165.4 90.945c-7.7433 4.258-10.527 13.963-6.2186 21.678l81.567 146.04c4.3088 7.714 14.079 10.517 21.822 6.26l165.4-90.945c7.743-4.258 10.527-13.963 6.219-21.678l-81.567-146.04c-4.309-7.7149-14.079-10.518-21.822-6.26z"
        className="rect-2"
      />
      <path
        d="m145.05 167.17-73.608 40.472c-2.6617 1.464-3.6188 4.8-2.1376 7.452 1.4811 2.652 4.8396 3.615 7.5014 2.152l73.607-40.472c2.662-1.464 3.619-4.8 2.138-7.452s-4.84-3.616-7.501-2.152z"
        className="rect-3"
      />
      <path
        d="m242.14 140.03-161.23 88.654c-1.6939 0.931-2.3029 3.054-1.3603 4.742 0.9425 1.687 3.0797 2.3 4.7736 1.369l161.23-88.653c1.694-0.931 2.303-3.055 1.36-4.742-0.943-1.688-3.08-2.301-4.774-1.37z"
        className="rect-3"
      />
      <path
        d="m247.5 149.64-161.23 88.654c-1.6939 0.931-2.3029 3.054-1.3603 4.742 0.9425 1.687 3.0797 2.3 4.7736 1.369l161.23-88.653c1.694-0.931 2.303-3.055 1.36-4.742-0.942-1.688-3.079-2.301-4.773-1.37z"
        className="rect-3"
      />
      <path
        d="m252.38 158.36-161.23 88.654c-1.6939 0.931-2.3029 3.054-1.3603 4.742 0.9425 1.687 3.0797 2.3 4.7736 1.369l161.23-88.653c1.694-0.931 2.303-3.055 1.36-4.742-0.942-1.688-3.079-2.301-4.773-1.37z"
        className="rect-3"
      />
      <path
        d="m170.66 228.4-69.225 38.064c-1.4523 0.798-1.9744 2.618-1.166 4.064 0.807 1.447 2.639 1.972 4.091 1.174l69.226-38.063c1.452-0.798 1.974-2.618 1.166-4.065-0.808-1.446-2.64-1.972-4.092-1.174z"
        className="rect-3"
      />
      <path
        d="m184.55 17.939-165.4 90.945c-7.6154 4.187-10.354 13.732-6.1159 21.32l81.567 146.04c4.2377 7.588 13.846 10.344 21.462 6.157l165.4-90.945c7.615-4.187 10.353-13.732 6.115-21.32l-81.566-146.04c-4.238-7.5874-13.847-10.344-21.462-6.1566z"
        className="rect-5"
        strokeWidth=".52858"
      />
      <path
        d="m487.53 95.258-184.12-17.999c-9.617-0.9401-18.187 6.0928-19.142 15.708l-16.704 168.22c-0.954 9.616 6.068 18.173 15.685 19.113l184.12 17.999c9.617 0.94 18.187-6.093 19.142-15.708l16.704-168.22c0.954-9.616-6.068-18.173-15.685-19.113z"
        className="rect-2"
      />
      <path
        d="m373.77 198.68-84.597-8.27c-3.023-0.295-5.717 1.915-6.017 4.938-0.301 3.023 1.907 5.713 4.93 6.008l84.597 8.27c3.023 0.296 5.717-1.915 6.017-4.938s-1.907-5.713-4.93-6.008z"
        className="rect-3"
      />
      <path
        d="m471.42 232.34-186.11-18.194c-2.199-0.215-4.158 1.393-4.376 3.591-0.219 2.199 1.387 4.155 3.586 4.37l186.11 18.194c2.199 0.214 4.158-1.393 4.377-3.592 0.218-2.198-1.387-4.154-3.586-4.369z"
        className="rect-3"
      />
      <path
        d="m470.33 243.29-186.11-18.194c-2.199-0.215-4.158 1.393-4.376 3.591-0.219 2.199 1.387 4.155 3.586 4.37l186.11 18.194c2.199 0.214 4.158-1.393 4.377-3.592 0.218-2.198-1.387-4.154-3.586-4.369z"
        className="rect-3"
      />
      <path
        d="m469.24 254.23-186.11-18.194c-2.199-0.215-4.158 1.393-4.376 3.591-0.219 2.199 1.387 4.155 3.586 4.37l186.11 18.194c2.199 0.214 4.158-1.393 4.377-3.592 0.218-2.198-1.387-4.154-3.586-4.369z"
        className="rect-3"
      />
      <path
        d="m359.09 265.57-78.626-7.686c-1.923-0.189-3.638 1.218-3.829 3.142-0.191 1.923 1.214 3.635 3.138 3.823l78.625 7.686c1.924 0.188 3.638-1.219 3.829-3.142 0.191-1.924-1.214-3.635-3.137-3.823z"
        className="rect-3"
      />
      <path
        d="m487.51 95.526-184.12-17.999c-9.47-0.9256-17.908 5.9991-18.848 15.467l-16.704 168.22c-0.94 9.468 5.974 17.893 15.443 18.819l184.12 17.999c9.47 0.925 17.908-6 18.848-15.467l16.704-168.22c0.94-9.467-5.974-17.893-15.444-18.818z"
        strokeWidth=".53819"
        className="rect-5"
      />
      <path
        d="m10.162 125.6c-5.3993-9.636-1.9646-21.825 7.6716-27.224l157.57-88.289c9.636-5.3992 21.825-1.9646 27.224 7.6716l41.541 74.138-192.47 107.84-41.541-74.138z"
        className="rect-3"
      />
      <path
        d="m284.75 93.198c0.989-9.8918 9.811-17.108 19.702-16.119l183.87 18.395c8.792 0.8797 15.207 8.7207 14.327 17.514l-8.642 86.384-217.7-21.78 8.443-84.394z"
        className="rect-3"
      />
    </Icon>
  )
}
